import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { TokenService } from './token.service';
import { User } from './models';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';


@Injectable()
export class AuthService {
  constructor (
    private apiService: ApiService,
    private tokenService: TokenService,
    private router: Router
  ) {}

  getAuth(email?, password?) {
    if (this.tokenService.getToken()) {
      // has token already, use that to set the user
      this.refreshToken();
      // for now it just uses the token currently available =====> but maybe it should do a token refresh?
    } else if (email && password) {
      this.passwordAuth(email, password);
    } else {
      // purge any existing auth and send user back to login page
      this.purgeAuth();
      this.router.navigate(['login']);
    }
  }

  setAuth(user: User) {
    // Save Token sent from server in localstorage
    this.tokenService.saveToken(user);
  }

  purgeAuth() {
    // Remove Token from localstorage
    this.tokenService.destroyToken();
  }

  passwordAuth(email: string, password: string, makeObservable?: boolean) {
    if (makeObservable) {
      return Observable.create((observer) => {
        this.apiService.postPicasso('authenticate', {
          email: email,
          password: password
        }).subscribe(
          data => {
            this.setAuth(data);
            observer.next(this.tokenService.currentUser);
          },
          err => {
            this.purgeAuth();
            observer.error(err);
          }
        );
      });
    } else {
      // login the user using email/password
      this.apiService.postPicasso('authenticate', {
        email: email,
        password: password
      }).subscribe(
        data => this.setAuth(data),
        err => this.purgeAuth()
      );
    }
  }

  tokenAuth(email: string, token: string) {
    this.apiService.postPicasso('tokenized_authenticate', {
      email: email,
      token: token
    }).subscribe(
      data => this.setAuth(data),
      err => this.purgeAuth()
    );
  }

  refreshToken() {
    this.apiService.postPicasso('refresh_token', {
      token: this.tokenService.currentUser.token
    }).subscribe(
      data => {
        console.log('refreshed token');
        this.tokenService.currentUser.token = data.token;
        this.tokenService.saveToken(this.tokenService.currentUser);
        // Need it to retry the API request here?
      },
      err => {
        console.log('refresh token error', err);
        // purge any existing auth and send user back to login page
        this.purgeAuth();
        this.router.navigate(['login']);
      }
    );
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/services/auth.service.ts